<template>
  <v-dialog v-model="dialog" max-width="500px">
    <v-form ref="form" @submit.prevent="() => $emit('salvar', lei)">
      <v-card v-if="lei" :loading="salvando">
        <v-card-title> {{ operacao === 'editar' ? 'Editar' : 'Adicionar' }} Lei </v-card-title>
        <v-card-text>
          <v-form ref="formDialog" v-model="validForm" @submit.prevent>
            <v-container>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="lei.nome"
                    label="Nome"
                    required
                    :rules="[obrigatorio]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="lei.codigo"
                    label="Codigo"
                    required
                    :rules="[obrigatorio]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-switch
                    v-model="lei.icms"
                    label="ICMS"
                    dense
                    @change="lei.piscofins = !lei.icms"
                  />
                </v-col>
                <v-col>
                  <v-switch
                    v-model="lei.piscofins"
                    label="PIS / COFINS"
                    dense
                    @change="lei.icms = !lei.piscofins"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-alert v-if="showMessageError" dense outlined type="error">
                    {{ dataError }}
                  </v-alert>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" type="button" text @click="dialog = false">Cancelar</v-btn>
          <v-btn
            class="ml-auto"
            type="submit"
            text
            color="success"
            :disabled="!validForm"
            @click="salvar(lei)"
            >Salvar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import Lei from '../../models/lei'
import LeiService from '../../services/lei/lei'
import { obrigatorio } from '../../shareds/regrasForm'

export default {
  props: ['showDialog', 'leiParam', 'operacao', 'itens'],
  data: () => ({
    dialog: false,
    lei: new Lei(),
    obrigatorio: obrigatorio,
    salvando: false,
    validForm: false,
    dataError: '',
    showMessageError: false
  }),
  watch: {
    showDialog() {
      this.showMessageError = false
      return this.showDialog ? (this.dialog = this.showDialog) : ''
    },
    leiParam() {
      return this.leiParam ? this.initialize() : ''
    },
    dialog() {
      return this.dialog ? true : this.fecharDialog()
    }
  },
  methods: {
    initialize() {
      this.lei = new Lei()
      if (this.$refs.formDialog) this.$refs.formDialog.resetValidation()

      this.lei = this.leiParam
    },

    async salvar(item) {
      this.salvando = true
      this.showMessageError = false
      try {
        const data = {
          ...item,
          icms: item.icms === undefined ? false : item.icms,
          piscofins: item.piscofins === undefined ? false : item.piscofins
        }

        const leiSalva =
          this.operacao === 'adicionar'
            ? await LeiService.create({ ...data })
            : await LeiService.update(data.id, data)

        this.$emit('confirmado', leiSalva)
        this.dialog = false
      } catch (error) {
        this.dataError = error.response.data.message
        this.showMessageError = true
      } finally {
        this.salvando = false
      }
    },

    fecharDialog() {
      this.$emit('update:showDialog', false)
    }
  }
}
</script>
